(function ($) {
  $(function () {
    if ($('.statistics-large .statistics__number').length) {
      $('.statistics-large .statistics__number').counterUp({
        delay: 10,
        time: 2000
      });
    }
  });
})(jQuery);